import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/productAnalytics';

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    if (window.gtag) {
      window.gtag('config', 'G-3WQRTQY9CG', {
        page_path: pagePath,
      });
    }

    // Keep product funnels clean: ignore super-admin console navigation.
    if (!location.pathname.startsWith('/super-admin') && !location.pathname.startsWith('/super/')) {
      trackPageView(location.pathname);
    }
  }, [location]);

  return null;
}

export default PageTracker;
